import { AuthRepository } from "../../../../data/repository/auth/AuthRepository";
import { CustomerRepository } from "../../../../data/repository/customer/CustomerRepository";
import { AccessToken, Auth } from "../../../model/Auth";
import { Customer } from "../../../model/Customer";
import { ResponseState, State } from "../../../model/ResponseState";

export interface SearchCustomersUseCase {
  invoke: (search: string) => Promise<ResponseState<Array<Customer>>>;
}

export class SearchCustomersUseCaseImpl implements SearchCustomersUseCase {
  private repository: CustomerRepository;

  constructor(repository: CustomerRepository) {
    this.repository = repository;
  }

  async invoke(search: string): Promise<ResponseState<Array<Customer>>> {
    try {
      let response = await this.repository.search(search);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
